export const SET_AUTO_DIAL = "SET_AUTO_DIAL";
export const SET_AUTO_DIAL_PAUSED = "SET_AUTO_DIAL_PAUSED";
export const SET_AUTO_DIAL_CAMPAIGN = "SET_AUTO_DIAL_CAMPAIGN";
export const SET_PENDING_STATUS_REASON = "SET_PENDING_STATUS_REASON";
export const SET_LAST_ASSIGNMENTID = "SET_LAST_ASSIGNMENTID";
export const GET_NEXT_ASSIGNMENT = "GET_NEXT_ASSIGNMENT";
export const SET_DIAL_MODE = "SET_DIAL_MODE";
export const RESET_AGENT_STATE = "RESET_AGENT_STATE";
export const SET_SELECTED_AGENT_ID = "SET_SELECTED_AGENT_ID";
export const SET_SELECTED_APPROVAL = "SET_SELECTED_APPROVAL";

export const SET_CALL_SCHEDULE_ASSIGNMENT_ID =
  "SET_CALL_SCHEDULE_ASSIGNMENT_ID";

export const SET_BROADCAST_LIST_TABLE_PAGE = "SET_BROADCAST_LIST_TABLE_PAGE";

export const SET_BROADCAST_DETAIL_TABLE_PAGE =
  "SET_BROADCAST_DETAIL_TABLE_PAGE";

export const SET_AGENT_SELECTED_ASSIGNMENT = "SET_AGENT_SELECTED_ASSIGNMENT";
export const SET_IS_SELECTING_CONTACT = "SET_IS_SELECTING_CONTACT";
export const SET_SELECTED_CHAT = "SET_SELECTED_CHAT";
export const SET_ASSIGNMENT_CHAT_LIST_ID = "SET_ASSIGNMENT_CHAT_LIST_ID";
